import React, { Component } from 'react'
import { Tabs } from 'antd';
import img1 from '../../../static/images/pos-banner.jpg'
import imgTop from '../../../static/images/pos-banner-top.png'
import product1 from '../../../static/images/product-1.png'
import product2 from '../../../static/images/product-2.png'
import product3 from '../../../static/images/product-3.png'
import product4 from '../../../static/images/product-4.png'
import product5 from '../../../static/images/product-5.png'
// import product6 from '../../../static/images/product-6.png'
// import product7 from '../../../static/images/product-7.png'
// import product8 from '../../../static/images/product-8.png'

import fun1 from '../../../static/images/fun1.png'
import fun2 from '../../../static/images/fun2.png'
import fun3 from '../../../static/images/fun3.png'
import fun4 from '../../../static/images/fun4.png'
import fun5 from '../../../static/images/fun5.png'
import fun6 from '../../../static/images/fun6.png'
import fun7 from '../../../static/images/fun7.png'
import fun8 from '../../../static/images/fun8.png'

import memberTop from '../../../static/images/member-top.png'
import member1 from '../../../static/images/member1.png'
import serviceBanner from '../../../static/images/case-banner.png'
import selected from '../../../static/images/selete.png'

import advantage2 from '../../../static/images/advantage2.png'
import advantage3 from '../../../static/images/advantage3.png'
import advantage4 from '../../../static/images/advantage4.png'
import advantage5 from '../../../static/images/advantage5.png'


import './index.less';
const { TabPane } = Tabs;
class Pos extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product1, title: '安卓收银机' },
            { img: product1, title: 'PC管理后台' },
            { img: product1, title: '自主收银机' },
            { img: product1, title: '智能POS机' },
            { img: product1, title: 'APP端' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }

    componentDidMount() {
        this._onPosIframeMessage = (e) => {
            // console.log(e,'............_onPosIframeMessage............')
            const d = e.data
            if (!d || d.source !== 'pos-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onPosIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onPosIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from pos.html
        }
    }

    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (

            <div style={{ width: '100%' }}>
                 <iframe 
                 title="pos-static"
                 src={`${process.env.PUBLIC_URL}/static/pos/pos.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>


            // <div className="product_container pos-container unattended-container affiliate-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">悦喵AI收银POS系统</div>
            //                     <div className="banner-top-tips">多门店管理、多场景赋能，满足各行业、各业态的一站式门店数字化平台</div>
            //                     <div className="banner-top-btn">立即体验</div>
            //                 </div>
            //                 {/* <img className="content-right-img" src={imgTop} alt="" /> */}
                            
            //             </div>
                        
            //         </div>
            //     </div>
            //     <div className="common-block-home">
            //         <div className="common-block-home-title">产品功能</div>
            //         <div className="common-block-home-tips">悦喵AI收银系统多端联动</div>
            //         <div className="common-block-product">
            //             {
            //                 customerList && customerList.map((item, index) => (
            //                     <div className="common-model" key={index}>
            //                         <div className="common-model-img">
            //                             <img className="img-style" src={item.img} alt="" />
            //                         </div>
            //                         <div className="common-model-title">{item.title}</div>
            //                     </div>
            //                 ))
            //             }

            //         </div>
            //     </div>

            //     <div className="common-block-home">
            //         <div className="common-block-home-title">全方位助力门店管理</div>
            //         <div className="common-block-product">
            //             <div className="store-model">
            //                 <div className="store-model-index">01
            //                 </div>
            //                 <div className="store-model-title">功能强大
            //                 </div>
            //                 <div className="store-model-tips">400+功能细节，一套系统覆盖全业务</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-index">02
            //                 </div>
            //                 <div className="store-model-title">O2O全渠道
            //                 </div>
            //                 <div className="store-model-tips">线上门店与线下门店数据互通，一体化运营</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-index">03
            //                 </div>
            //                 <div className="store-model-title">全场景营销
            //                 </div>
            //                 <div className="store-model-tips">多种营销工具，助力营收</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-index">04
            //                 </div>
            //                 <div className="store-model-title">全方位数据决策
            //                 </div>
            //                 <div className="store-model-tips">80+报表，助力门店经营决策</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-index">05
            //                 </div>
            //                 <div className="store-model-title">云端同步
            //                 </div>
            //                 <div className="store-model-tips">离线收银，断电、断网数据不丢失</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-index">06
            //                 </div>
            //                 <div className="store-model-title">移动管店
            //                 </div>
            //                 <div className="store-model-tips">手机APP，随时随地就行门店日常管理</div>
            //             </div>


            //         </div>
            //     </div>

            //     <div className="common-block-home product-page">
            //         <div className="common-block-home-title">功能模块</div>
            //         <div className="common-block-product">
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">SAAS收银</div>
            //                 <div className="product-detail-tips">支持多业态便利收银</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun2} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">融合支付</div>
            //                 <div className="product-detail-tips">前台一键融合 支付宝/微信支付</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun3} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">O2O平台</div>
            //                 <div className="product-detail-tips">对接微信、美团、饿了么等主流平台</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun4} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">会员管理</div>
            //                 <div className="product-detail-tips">自助入会、在线储值、线上线下核销、互动营销活动</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun5} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">门店库存成本核销</div>
            //                 <div className="product-detail-tips">门店物料进出库及成本核销</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun6} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">APP手机订货</div>
            //                 <div className="product-detail-tips">库存查询、盘点、采购、配送、收货等管理</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun7} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">决策报表</div>
            //                 <div className="product-detail-tips">掌握营业数据，并通过数据管理门店</div>
            //             </div>
            //             <div className="product-detail product-detail-page">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={fun8} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">小程序商城</div>
            //                 <div className="product-detail-tips">通过拼团、秒杀、社区团购、直播等营销方式，提高销量</div>
            //             </div>
            //         </div>

            //     </div>

            //     {/* <div className="common-block-home">
            //         <div className="common-block-home-title">会员管理，客户一批接着一批的来</div>
            //         <div className="common-block-home-tips">智能会员CRM提升客户粘度</div>
            //         <div className="member-detail">
            //             <img className="member-img-style" src={memberTop} alt="" />
            //             <div className="member-icon-list">
            //                 <div className="member-icon-flex">
            //                     <div className="member-icon-div">
            //                         <img className="icon-img-style" src={member1} alt="" />
            //                     </div>
            //                     <div className="member-title">会员资料</div>
            //                 </div>
            //                 <div className="member-icon-flex">
            //                     <div className="member-icon-div">
            //                         <img className="icon-img-style" src={member1} alt="" />
            //                     </div>
            //                     <div className="member-title">会员类别</div>
            //                 </div>
            //                 <div className="member-icon-flex">
            //                     <div className="member-icon-div">
            //                         <img className="icon-img-style" src={member1} alt="" />
            //                     </div>
            //                     <div className="member-title">会员储值</div>
            //                 </div>
            //                 <div className="member-icon-flex">
            //                     <div className="member-icon-div">
            //                         <img className="icon-img-style" src={member1} alt="" />
            //                     </div>
            //                     <div className="member-title">会员积分</div>
            //                 </div>
            //                 <div className="member-icon-flex">
            //                     <div className="member-icon-div">
            //                         <img className="icon-img-style" src={member1} alt="" />
            //                     </div>
            //                     <div className="member-title">会员折扣</div>
            //                 </div>
            //                 <div className="member-icon-flex">
            //                     <div className="member-icon-div">
            //                         <img className="icon-img-style" src={member1} alt="" />
            //                     </div>
            //                     <div className="member-title">会员分析</div>
            //                 </div>
                            
            //             </div>
            //         </div>
            //     </div> */}

            //     {/* <div className="common-block-home">
            //         <div className="common-block-home-title">多种门店经营数据报表辅助经营</div>
            //         <div className="common-block-home-tips">销售额、商品流水、毛利等各项经营数据的日、周、月汇总报表随时查看，滞销商品、畅销商品智能推送，门店经营不再只靠感觉</div>
            //         <div className="member-detail">
            //             <img className="member-img-style" src={memberTop} alt="" />
            //         </div>
            //     </div>
            //     <div className="common-block-home">
            //         <div className="common-block-home-title">断网收银，收银卖货不耽误</div>
            //         <div className="common-block-home-tips">支持断网收银，无网络情况下72小时扔可正常销售，恢复网络后自动上传销售收银数据，无感式应对突发状况</div>
            //         <div className="member-detail">
            //             <img className="member-img-style" src={memberTop} alt="" />
            //         </div>
            //     </div> */}

            //     <div className="common-block-home advantage-common-block-home">

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">全渠道会员管理，提升客户粘度</div>
            //                     <div className="advantage-detail-left-tips">打通微信、支付宝 原生电子会员卡,高效精准的抓住每一个消费者,帮助商户快速的积累门店的私域流量。</div>
            //                     <div className="advantage-detail-left-tips">通过会员储值、会员积分、会员积分、会员折扣、会员分析实现会员的精准标签、精准触达,、精准营销</div>
            //                 </div>
                           
            //             </div>

            //         </div>
                   
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">多渠道订单整合</div>
            //                     <div className="advantage-detail-left-tips">对接美团外卖、饿了么平台订单，用收银系统就能处理外卖订单。</div>
            //                     <div className="advantage-detail-left-tips">对接线上订单，网站下单后智能分单，就近门店发货，在缓解供应链压力的同事，协助门店销货。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage3} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">多种门店经营数据报表辅助经营</div>
            //                     <div className="advantage-detail-left-tips">销售额、商品流水、毛利等各项经营数据的日、周、月汇总报表随时查看，滞销商品畅销商品智能推送，门店经营不再只靠感觉</div>
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">断网断电都不怕</div>
            //                     <div className="advantage-detail-left-tips">桌面收银在断网的情况下，将自动启用离线收银，离线可正常收银、使用营销活动、查看订单、交接班，满足门店最基本的收银操作；待网络恢复后，订单自动上传云端，确保营业不中断、营业数据不丢失。</div>
            //                     <div className="advantage-detail-left-tips">在断电或APP被强退的情况下，则可将当前收银自动挂单，待重启服务后，取单即可继续未完操作。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage5} alt="" />
            //                 </div>
            //             </div>
            //         </div>

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">常用店铺管理功能</div>
            //                     <div className="advantage-detail-left-tips">小票模板管理、标签模板管理、商品建档、商品调价、会员查询、积分兑换商品/优惠券、库存查询、库存盘点、常用出入库、寄存取件......以上这些门店常用的店铺管理，即使不打开商户平台，收银员也可在收银机正常操作，一个终端覆盖收银员的全部业务，省时省力。</div>
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">多种支付方式的组合支付</div>
            //                     <div className="advantage-detail-left-tips">桌面收银深度集成了现金、支付宝、微信支付、云闪付、储值卡、预付卡、次卡、积分、赊账、自定义支付等支付方式，并且支持任意支付方式的多种组合（次卡除外），支付完成自动确认，线上线下全方位整合。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage5} alt="" />
            //                 </div>
            //             </div>
            //         </div>

            //     </div>

            //     <div className="common-block-home hardware-page">
            //         <div className="common-block-home-title">高度兼容，主流硬件即插即用</div>
            //         <div className="common-block-product">
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">扫描枪</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product2} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">打印机</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product3} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">钱箱</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product4} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">客显</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product5} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">电子称</div>
            //             </div>
            //         </div>

            //     </div>

            //     <div className="common-block-home mobile-tool-page">
            //         <div className="common-block-home-title">手机移动工具，随时都能管好店</div>
            //         <Tabs className="common-block-case-tabs" tabPosition="top">
            //             <TabPane tab="管理小程序" key="1">
            //                 <div className="top-home-carousel">
            //                     <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //                     <div className="mode-mark"></div>
            //                     <div className="mask-top-content">
            //                         <div className="content-pos">
            //                             <img className="content-right-img" src={imgTop} alt="" />
            //                             <div className="content-left-text">
            //                                 <div className="banner-top-title">管店小程序</div>
            //                                 <div className="banner-top-tips">
            //                                     <img className="content-right-img" src={selected} alt="" />
            //                                     手机建档，快速调价，库存查询，订货退货，调拨收货，会员营销，数据报表
            //                                     </div>
            //                                 <div className="banner-top-btn">了解更多</div>
            //                             </div>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </TabPane>
            //             <TabPane tab="手机收银APP" key="2">
            //                 <div className="top-home-carousel">
            //                     <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //                     <div className="mode-mark"></div>
            //                     <div className="mask-top-content">
            //                         <div className="content-pos">
            //                             <img className="content-right-img" src={imgTop} alt="" />
            //                             <div className="content-left-text">
            //                                 <div className="banner-top-title">管店小程序</div>
            //                                 <div className="banner-top-tips">
            //                                     <img className="content-right-img" src={selected} alt="" />
            //                                     手机建档，快速调价，库存查询，订货退货，调拨收货，会员营销，数据报表
            //                                 </div>
            //                                 <div className="banner-top-btn">了解更多</div>
            //                             </div>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </TabPane>
            //         </Tabs>
                    
                    
            //     </div>


            //     <div className="common-block-home">
            //         <div className="common-block-home-title">技术服务，专业护航更放心</div>
            //         <div className="member-detail-service">
            //             <img className="member-img-style" src={serviceBanner} alt="" />
            //         </div>
            //         <div className="service-tips">使用过程中遇到问题可联系天电店技术团队，全力为您解答疑惑，解决问题</div>
            //     </div>


            // </div >
        )
    }
}


export default Pos